import * as React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const TriangleRightIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 16 16" focusable="false" aria-hidden="true">
    <path d="M11 8 5 4v8l6-4Z" className="filled stroke-linejoin-round" fill="currentColor" strokeLinejoin="round" />
  </SvgIcon>
);

export default TriangleRightIcon;
